<template>
	<c-dialog ref="dialog" height="540" width="500" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="供应商编号">
				<c-input name="supplier_code" placeholder="请输入，忽略将自动生成"></c-input>
			</c-form-item>
			<c-form-item label="供应商名称" required>
				<c-input name="supplier_name"></c-input>
			</c-form-item>
			<c-form-item label="供应商全称">
				<c-input name="supplier_full_name"></c-input>
			</c-form-item>
			<c-form-item label="联系人">
				<c-input name="contact_name"></c-input>
			</c-form-item>
			<c-form-item label="联系电话">
				<c-input name="contact_phone"></c-input>
			</c-form-item>
			<c-form-item label="联系地址">
				<c-input name="contact_address"></c-input>
			</c-form-item>
			<!--自定义字段控件-->
			<custom-form ref="customForm" work-type="12"></custom-form>
		</c-form>
	</c-dialog>
</template>

<script>
export default {
	name: 'supplierEdit',

	data() {
		return {
			
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data;
			
			this.$refs.form.clear();
			this.$refs.customForm.init();
			if (data) {
				this.$refs.form.set(data);
				
				//查询供应商详情
				this.request({
					url:'/supplier/detail',
					data: {
						id:data.id
					},
					success:data => {
						this.$refs.form.set(data);
					}
				})
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑供应商' : '创建供应商'
			});
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/supplier/edit':'/supplier/add',
				rule: {
					supplier_name: '请输入供应商名称',
					...this.$refs.customForm.rule
				},
				dataFormatter: data => {
					data.custom_fields_value_json = JSON.stringify(data.custom_fields_value_json);
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
</style>